





























































import { Component } from 'vue-mixin-decorator';
import RepositoryFactory from '@/repository/RepositoryFactory';
import BaseView from '@/views/BaseView.vue';
import ExamNav from '@/components/ExamNav.vue';
import ExamHeader from '@/components/ExamHeader.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import { replaceAudioElement } from '@/common/MediaUtil';

import Template from '@/models/template/Template';
import { template } from 'lodash';

@Component(
  {
    components: {
      'e-header': ExamHeader,
      'e-nav': ExamNav,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class ContentsTemplate extends BaseView {
  private template = new Template();

  private isIndicatorDisplay = false;

  /**
   * フッター（ボタンエリア）表示フラグ
   */
  get isShowFooters() {
    return this.template.templateFooters.length > 0;
  }

  private created() {
    this.init();
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 初期化処理
   */
  async init() {
    this.isIndicatorDisplay = true;
    await this.getTemplate()
      .then(() => {
        replaceAudioElement();
      });
    this.isIndicatorDisplay = false;
  }

  /**
   * テンプレート取得
   */
  async getTemplate() {
    // パスパラメータからテンプレートコードを取得
    const { templateCode } = this.$route.params;
    if (templateCode === undefined) {
      this.$router.replace(this.paths.TOP);
    }

    // テンプレート取得API呼び出し
    const templateRepo = RepositoryFactory.get().template;
    try {
      const response = await templateRepo.getTemplate(templateCode).catch((err) => {
        throw new Error(err.message);
      });
      this.template = templateRepo.convert.deserialize(response.data, Template) as Template;
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * MarkdownをHTMLに変換
   */
  // eslint-disable-next-line class-methods-use-this
  markdownToHtml(markdown?: string) {
    return MarkdownToHTML(markdown);
  }
}
